import React from 'react';

export default function Espaçador(props) {
  return <div style={{ paddingLeft: props.espaço }} />;
}
